import React from 'react';
import { useSelector } from 'react-redux';
import { PaymentLabContainer } from '@product-marketing/payment';

import PortalContainer from '@components/PortalContainer';
import Container from '@common/components/Container/Container';

export const SupportedPayments = () => {
  const { userProfile } = useSelector(state => state);
  const { customerId } = userProfile.user;

  return (
    <PortalContainer>
      <Container style={{ paddingBottom: '30px', minHeight: '1000px' }}>
        <PaymentLabContainer lucidId={customerId} />
      </Container>
    </PortalContainer>
  );
};
